import { createRouter, createWebHashHistory } from "vue-router";
import mainComponent from "@/components/mainComponent.vue";
import Supporters from "../views/Supporters.vue";
import HomeView from "@/views/HomeView.vue";
import employees from "@/views/employees.vue";
import groups from "@/views/groups.vue";
import problems from "@/views/problems.vue";
import Mobilisation from "@/views/mobilisation.vue";
import doorToDoor from "@/views/doorToDoor.vue";
import election from "@/views/election.vue"
import newsAndActivities from "@/views/newsAndActivities.vue";
import createOrganization from "@/views/createOrganization.vue"
import addOffice from "@/views/addOffice.vue";
import addPosition from "@/views/addPosition.vue";
import addMunicipality from "@/views/addMunicipality.vue";
import addCity from "@/views/addCity.vue";
import addRegion from "@/views/addRegion.vue";
import addDistrict from "@/views/addDistrict.vue";
import addUser from "@/views/addUser.vue";
import addMenuToUser from "@/views/addMenuToUser.vue";
import finalResults from "@/views/finalResults.vue"
import Login from "../views/LoginView.vue";
import store from "@/store/index.js"
import exitPoll from "@/views/exitPoll.vue";
import survey from "@/views/survey.vue";
import newSurvey from "@/views/newSurvey.vue";
import tasks from "@/views/tasks.vue";

const routes = [
  {
    path: "/",
    name: "main",
    component: mainComponent,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/",
        name: "election",
        component: election,
        meta: {
          menuID: 33,
        },
        // children: [
        //   {
        //     path: "/", // added as menu
        //     redirect: '/election',
        //     name: "employees",
        //     component: employees, 
        //   },
        //   // {
        //   //   path: "/groups",
        //   //   name: "groups",
        //   //   component: groups,
        //   // },
        // ]
      },
      {
        path: "/exitPoll",
        name: "exitPoll",
        component: exitPoll,
        meta: {
          menuID: 36,
        },
      },
      {
        path: "/finalResults",
        name: "finalResults",
        component: finalResults,
        meta: {
          menuID: 35,
        },
      },
      {
        path: "/supporters", // added as menu
        name: "supporters",
        component: Supporters,
        meta: {
          menuID: 2,
        },
      },
      {
        path: "/issue_tracking", // added as menu
        name: "problems",
        component: problems,
        meta: {
          menuID: 3,
        },
      },
      {
        path: "/mobilisation", // added as menu
        name: "mobilisation",
        component: Mobilisation,
        meta: {
          menuID: 4,
        },
      },
      {
        path: "/doorToDoor",// added as menu
        name: "doorToDoor",
        component: doorToDoor,
        meta: {
          menuID: 5,
        },
      },
      // {
      //   path: "/election",// added as menu
      //   name: "election",
      //   component: election,
      //   meta: {
      //     menuID: 15,
      //   },
      // },
      {
        path: "/newsAndActivities", // added as menu
        name: "newsAndActivities",
        component: newsAndActivities,
        meta: {
          menuID: 6,
        },
      },
      {
        path: "/createOrganization", // added as menu
        name: "createOrganization",
        component: createOrganization,
        meta: {
          requiresPePollAdminLevel: true,
          requiresAuth: true,
          menuID: 7,
        },
      },
      {
        path: "/addOffice",// added as menu
        name: "addOffice",
        component: addOffice,
        meta: {
          menuID: 8,
        },
      },
      {
        path: "/addPosition",// added as menu
        name: "addPosition",
        component: addPosition,
        meta: {
          menuID: 9,
        },
      },
      {
        path: "/addMunicipality", // added as menu
        name: "addMunicipality",
        component: addMunicipality,
        meta: {
          requiresPePollAdminLevel: true,
          requiresAuth: true,
          menuID: 10,
        },
      },
      {
        path: "/addCity", // added as menu
        name: "addCity",
        component: addCity,
        meta: {
          requiresPePollAdminLevel: true,
          requiresAuth: true,
          menuID: 11,
        },
      },
      {
        path: "/addRegion",// added as menu
        name: "addRegion",
        component: addRegion,
        meta: {
          requiresPePollAdminLevel: true,
          requiresAuth: true,
          menuID: 12,
        },
      },
      {
        path: "/addDistrict", // added as menu
        name: "addDistrict",
        component: addDistrict,
        meta: {
          requiresPePollAdminLevel: true,
          requiresAuth: true,
          menuID: 21,
        },
      },
      {
        path: "/addUser",// added as menu
        name: "addUser",
        component: addUser,
        meta: {
          menuID: 34,
        },
      },
      {
        path: "/addMenuToUser",// added as menu
        name: "addMenuToUser",
        component: addMenuToUser,
        meta: {
          menuID: 14,
        },
      },
      {
        path: "/survey",
        name: "survey",
        component: survey,
        meta: {
          menuID: null, // 14 for testing
        },
      },
      {
        path: "/newSurvey",
        name: "newSurvey",
        component: newSurvey,
        meta: {
          menuID: null, // 14 for testing
        },
      },
      {
        path: "/tasks",
        name: "tasks",
        component: tasks,
        meta: {
          menuID: null, // 14 for testing
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth && record.meta.requiresPePollAdminLevel)){
    if(store?.state?.userInfo?.is_active == 1 && localStorage.getItem("BearerToken")){
      
      let isMenuActive = store.state.userInfo.user_menus.some((menuObj) => {
        if(menuObj.is_active == 1){
          let result = ((menuObj.menuID == to.meta.menuID) && menuObj?.menu?.is_mobile == 0);
          return result;
        }else{
          return false;
        }
      })
      if(store.state.userInfo.added_by == 0 && isMenuActive){ // && isMenuActive
        store.dispatch("setCurrentMenuId", to.meta.menuID);
        next(true);
      }else{
        
        next(store.state?.userInfo?.user_menus[0]?.menu.menu_link??false);
      }
    }else if(localStorage.getItem("BearerToken")){
      await store.dispatch("getInfoOnRefresh");
      
      if(store?.state?.userInfo?.is_active == 1){
        let isMenuActive = store.state.userInfo.user_menus.some((menuObj) => {
          if(menuObj.is_active == 1){
            let result = ((menuObj.menuID == to.meta.menuID) && menuObj?.menu?.is_mobile == 0);
            return result;
          }else{
            return false;
          }
        })
        if(store.state.userInfo.added_by == 0 && isMenuActive){ // && isMenuActive
          store.dispatch("setCurrentMenuId", to.meta.menuID);
          next(true);
        }else{
          next(store.state?.userInfo?.user_menus[0]?.menu.menu_link??false);

        }
      }else{
        router.back();
      }
    }else{
      next("/login");
    }

  }else if(to.matched.some(record => record.meta.requiresAuth)){
    
    if(store?.state?.userInfo?.is_active == 1 && localStorage.getItem("BearerToken")){
      
      let isMenuActive = store.state.userInfo.user_menus.some((menuObj) => {
        if(menuObj.is_active == 1){
          let result = ((menuObj.menuID == to.meta.menuID) && menuObj?.menu?.is_mobile == 0);
          return result;
        }else{
          return false;
        }
      })
      
      if(isMenuActive){
        store.dispatch("setCurrentMenuId", to.meta.menuID);
        next(true);
      }else{
        next(store.state?.userInfo?.user_menus[0]?.menu.menu_link??false);

      }
    }else if(localStorage.getItem("BearerToken")){
      await store.dispatch("getInfoOnRefresh");
      if(store?.state?.userInfo?.is_active == 1){
        let isMenuActive = store.state.userInfo.user_menus.some((menuObj) => {
          if(menuObj.is_active == 1){
            let result = ((menuObj.menuID == to.meta.menuID) && menuObj?.menu?.is_mobile == 0);
            return result;
          }else{
            return false;
          }
        })
        if(isMenuActive){
          store.dispatch("setCurrentMenuId", to.meta.menuID);
          next(true);
        }else{
          next(store.state?.userInfo?.user_menus[0]?.menu.menu_link??false);

        }
      }else{
        router.back();
      }
    }else{
      next("/login");
    }
  }else{
    next(true);
  }
})

export default router;
